<!-- Modal Overlay -->
<div class="modal-overlay">
    <!-- Modal Content -->
    <div class="modal-content custom-modal-content p-4">
        <!-- Header Row: Title + Share + Toggle + Contact Owner -->
        <div class="property-header d-flex justify-content-between align-items-start flex-wrap" style="position: sticky; top: 0; z-index: 10; background: white;">
            <!-- Title -->
            <div class="uni-main-title mb-2">{{ propertyTitle }}</div>
            <!-- Right-side Buttons -->
            <div class="d-flex align-items-center gap-3 mb-2">
                <!-- Toggle View Button -->
                <button class="btn" title="Toggle View" (click)="toggleView()">
                    <i class="bi" [ngClass]="isCardView ? 'bi-grid-fill' : 'bi-image'" style="color: #011044;"></i>
                </button>
                <!-- Share Icon Button -->
                <button class="btn" title="Share">
                    <i class="bi bi-share-fill" style="color: #011044;"></i>
                </button>
                <!-- Contact Owner Button -->
                <button class="universal-submit-btn">
                    Contact Owner
                </button>
                <!-- Close Button -->
                <button class="btn-close ms-2" aria-label="Close" (click)="closeModal()"></button>
            </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs custom-tabs mt-3" role="tablist" style="position: sticky; top: 60px; z-index: 10; background: white;">
            <li class="nav-item" role="presentation" *ngFor="let category of categories; let i = index">
                <button class="nav-link" [class.active]="activeCategory === category" (click)="setActiveCategory(category)" data-bs-toggle="tab" [attr.data-bs-target]="'#' + getTabId(category)" type="button" role="tab">{{category}} ({{getImageCount(category)}})</button>
            </li>
        </ul>

        <!-- Tabs Content -->
        <div class="tab-content pt-1" style="overflow-y: auto;">
            <div class="tab-pane fade" [class.show]="activeCategory === category" [class.active]="activeCategory === category" [id]="getTabId(category)" role="tabpanel" *ngFor="let category of categories">
                <!-- Card View -->
                <div *ngIf="isCardView" class="image-gallery-wrapper d-flex flex-wrap justify-content-center align-items-center gap-3 py-4">
                    <div *ngFor="let image of getImagesForCategory(category)" class="gallery-image-container" (click)="selectImage(category, image)">
                        <img [src]="image.imgPath || 'https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg'" [alt]="category" class="img-fluid rounded" style="width: 500px; height: 300px; object-fit: cover; cursor: pointer;" />
                    </div>
                </div>
                <!-- Single-Image View -->
                <div *ngIf="!isCardView" class="image-slider-wrapper d-flex justify-content-center align-items-center position-relative py-4">
                    <button class="slider-arrow d-none d-md-flex" (click)="prevImage(category)">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <img [src]="getCurrentImage(category)?.imgPath || 'https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg'" [alt]="category" class="img-fluid slider-image rounded" />
                    <button class="slider-arrow d-none d-md-flex" (click)="nextImage(category)">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>